var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBq = function SvgBq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M3.515 3.514a11.973 11.973 0 0 0-3.48 9.384L12.898.033a11.972 11.972 0 0 0-9.384 3.481Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M4.285 21.19c4.715 3.966 11.763 3.732 16.2-.706 4.438-4.437 4.673-11.485.706-16.2L4.285 21.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m11.957 11.517 1.034-.56-1.034-.56a3.655 3.655 0 0 0-3.05-3.05l-.56-1.034-.56 1.034a3.655 3.655 0 0 0-3.049 3.05l-1.034.56 1.034.56a3.655 3.655 0 0 0 3.05 3.049l.56 1.034.56-1.034a3.655 3.655 0 0 0 3.049-3.05Zm-3.61 1.527a2.087 2.087 0 1 1 0-4.174 2.087 2.087 0 0 1 0 4.174Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m8.348 9.39.451.784h.904l-.452.782.452.783H8.8l-.452.782-.452-.782h-.904l.452-.783-.452-.782h.904l.452-.783Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBq;